import './styles/App.scss';

import Header from './components/common-header/Header';
import MoreToRead from './components/MoreToRead';
import Footer from './components/common-footer/Footer';
import Hero from './components/Hero';
import Body from './components/Body';
import Footnotes from './components/Footnotes';

function App() {
  return (
    <>
      <Header clientName={'Microsoft and Intel'} />
      <Hero />
      <Body />
      <Footnotes />
      <MoreToRead />
      <Footer />
    </>
  );
}

export default App;
